import { Params } from '@angular/router';

import { ASSESSMENT_ROUTE } from 'app/student/assessment/assessment-routing-constants';
import { ASSESSMENT_MODE_ROUTE } from 'app/student/assessment-mode/assessment-mode-routing.constant';
import { GAME_SECTION_ROUTE } from 'app/student/game-section/game-section-routing.constants';
// NOTE: name should be lowercase as lowercase serializer is used.
import { GAMEPLAY_ROUTE } from 'app/student/gameplay/gameplay-routing-constants';
import { GAMESHOW_ROUTE } from 'app/student/gameshow/gameshow-routing-constants';
import { LIGHTNING_ROUTE } from 'app/student/lightning/lightning-routing.constants';
import { MATHALON_ROUTE } from 'app/student/mathalon/mathalon-routing.constant';
import { MISSION_ROUTE } from 'app/student/mission/mission-routing.constant';
import { NOTIFICATIONS_ROUTE } from 'app/student/notifications/notifications-routing.constant';
import { GAME_SHOW_ROUTE } from '../student/game-show/game-show-routes.constants';

export const STUDENT_ROUTE = {
  name: 'student',
  route(): string[] {
    return ['/', this.name];
  },
  DEFAULT: '',

  LOGGED: {
    name: ':classId',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.route(), classId];
    }
  },

  ASSESSMENT_MODE: ASSESSMENT_MODE_ROUTE,
  ASSESSMENT: ASSESSMENT_ROUTE,
  HOME: {
    name: 'home',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  GAMEPLAY: GAMEPLAY_ROUTE,
  GAMESHOW: GAMESHOW_ROUTE,
  GAME_SHOW: GAME_SHOW_ROUTE, // this is the new game show route
  MISSION: MISSION_ROUTE,
  SKILL: {
    name: 'skill/:courseid/:branchid',
    route(classId: string, courseId: string, branchId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), 'skill', courseId, branchId];
    }
  },
  SKILL_MISSION: {
    name: 'skill/:courseid/:branchid/:missionid',
    route(classId: string, courseId: string, branchId: string, missionId: string): string[] {
      return [...STUDENT_ROUTE.SKILL.route(classId, courseId, branchId), missionId];
    }
  },
  SOLVE: {
    name: 'solve',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  MISSION_OR_SOLVE: {
    name: 'mission-or-solve',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  RESULTS_REPLAY: {
    name: 'resultsReplay',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  R_CHALLENGES: {
    name: 'rChallenges',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  NOTIFICATIONS: NOTIFICATIONS_ROUTE,
  MINISTRY_FEEDBACK: {
    name: 'ministry-feedback',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  MINISTRY_SURVEY: {
    name: 'ministry-survey',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  MATHALON: MATHALON_ROUTE,
  SELF_PROFILE: {
    name: 'profile',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
    }
  },
  PROFILE_NO_STUDENT_ID: {
    name: 'profile/:studentClassId',
    route(classId: string, studentClassId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), 'profile', studentClassId];
    }
  },
  PROFILE_FULL_PATH: {
    name: 'profile/:studentClassId/:studentId',
    route(classId: string, studentClassId: string, studentId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), 'profile', studentClassId, studentId];
    }
  },
  GAME_SECTION: GAME_SECTION_ROUTE,
  INVITE_PARENT: {
    name: 'inviteparent',
    route(studentClassId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(studentClassId), this.name];
    }
  },
  SETTINGS: {
    name: 'settings',
    route(studentClassId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(studentClassId), this.name];
    }
  },
  PORTFOLIO: {
    name: 'portfolio',
    route(studentClassId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(studentClassId), this.name];
    }
  },
  QUESTION_LEAGUE: {
    name: 'questionleague',
    route(studentClassId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(studentClassId), this.name];
    }
  },
  JOIN_CODE: {
    name: 'join',
    route(): string[] {
      return [...STUDENT_ROUTE.route(), this.name];
    },
    queryParams(state: string, redirectFromUrl = '', errors: string[] = []): Params {
      return {
        state: state || null,
        redirectfromurl: redirectFromUrl || null,
        errors: errors.length ? JSON.stringify(errors) : null
      };
    }
  },
  JOIN: {
    name: 'join/:classcode',
    route(classCode: string): string[] {
      return [...STUDENT_ROUTE.route(), 'join', classCode];
    },
    queryParams(state: string, action = '', redirectFromUrl = '', source = ''): Params {
      return {
        state: state || null,
        action: action || null,
        redirectfromurl: redirectFromUrl || null,
        source: source || null
      };
    }
  },
  LOGIN: {
    name: 'login',
    route(): string[] {
      return [...STUDENT_ROUTE.route(), this.name];
    },
    queryParams(redirectFromUrl = ''): Params {
      return {
        redirectfromurl: redirectFromUrl || null
      };
    }
  },
  QRCODE: {
    name: 'qrcode',
    route(): string[] {
      return [...STUDENT_ROUTE.route(), this.name];
    }
  },
  REGISTER: {
    name: 'register',
    route(): string[] {
      return [...STUDENT_ROUTE.route(), this.name];
    },
    queryParams(state: string, redirectFromUrl = ''): Params {
      return {
        state: state || null,
        redirectfromurl: redirectFromUrl || null
      };
    }
  },
  LIGHTNING: LIGHTNING_ROUTE,
  NO_CLASSES: {
    name: 'no-classes',
    route(): string[] {
      return [...STUDENT_ROUTE.route(), this.name];
    }
  },
  COMING_SOON: {
    name: 'coming-soon',
    route(classId: string): string[] {
      return [...STUDENT_ROUTE.LOGGED.route(classId), 'coming-soon'];
    }
  },
  PAGE_NOT_FOUND: {
    name: 'page-not-found',
    route(): string[] {
      return [...STUDENT_ROUTE.route(), this.name];
    },
    queryParams(classId: string): Params {
      return {
        classid: encodeURI(classId)
      };
    }
  }
};
